// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"04ac9f5b","937":"a375814f"}[chunkId] + ".chunk.css";
};